import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Mee › Phép của tôi (Leave.tsx). Mã nghiệp vụ và dữ liệu mẫu không dịch.
addMessages('vi', {
  'lv.none': 'Chưa có đơn nào',
  'lv.fund': 'Quỹ phép năm',
  'lv.year': 'Phép năm 2026',
  'lv.used': 'Đã dùng',
  'lv.pending': 'Chờ duyệt',
  'lv.left': 'Còn lại',
  'lv.byMonth': 'Ngày nghỉ theo tháng',
  'lv.taken': 'Đã nghỉ theo tháng',
  'lv.mine': 'Đơn của tôi',
  'lv.title': 'Phép của tôi',
  'lv.sub': '{n} ngày phép còn lại',
  'lv.create': 'Tạo đơn',
  'lv.withdraw': 'Rút đơn',
});
addMessages('en', {
  'lv.none': 'No requests yet',
  'lv.fund': 'Annual leave balance',
  'lv.year': 'Annual leave 2026',
  'lv.used': 'Used',
  'lv.pending': 'Pending',
  'lv.left': 'Remaining',
  'lv.byMonth': 'Days off by month',
  'lv.taken': 'Taken by month',
  'lv.mine': 'My requests',
  'lv.title': 'My leave',
  'lv.sub': '{n} leave days remaining',
  'lv.create': 'New request',
  'lv.withdraw': 'Withdraw',
});
